import { render, staticRenderFns } from "./gc-dashboard-sales-performance-card.vue?vue&type=template&id=950f5e82&scoped=true"
import script from "./gc-dashboard-sales-performance-card.vue?vue&type=script&lang=js"
export * from "./gc-dashboard-sales-performance-card.vue?vue&type=script&lang=js"
import style0 from "./gc-dashboard-sales-performance-card.vue?vue&type=style&index=0&id=950f5e82&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "950f5e82",
  null
  
)

export default component.exports